/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TagsTag from './TagsTag';

/**
 * The TagsBody model module.
 * @module model/TagsBody
 * @version v0.3
 */
export default class TagsBody {
  /**
   * Constructs a new <code>TagsBody</code>.
   * @alias module:model/TagsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TagsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TagsBody} obj Optional instance to populate.
   * @return {module:model/TagsBody} The populated <code>TagsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TagsBody();
      if (data.hasOwnProperty('tag'))
        obj.tag = TagsTag.constructFromObject(data['tag']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TagsTag} tag
 */
TagsBody.prototype.tag = undefined;

